const VIRTUAL_FILE_SYSTEM_CODE = `
import os as _os_module
import sys as _sys_module

_virtual_files = {}
_virtual_cwd = '/'

def _normalize_path(path):
    if not path.startswith('/'):
        path = _virtual_cwd + '/' + path
    parts = []
    for part in path.split('/'):
        if part == '' or part == '.':
            continue
        elif part == '..':
            if parts:
                parts.pop()
        else:
            parts.append(part)
    return '/' + '/'.join(parts)

class VirtualFile:
    def __init__(self, filename, mode):
        self.filename = _normalize_path(filename)
        self.mode = mode
        self.content = ''
        self.position = 0
        self.closed = False
        if 'r' in mode and self.filename in _virtual_files:
            self.content = _virtual_files[self.filename]
        elif 'w' in mode:
            _virtual_files[self.filename] = ''
            self.content = ''
        elif 'a' in mode:
            if self.filename in _virtual_files:
                self.content = _virtual_files[self.filename]
                self.position = len(self.content)
            else:
                _virtual_files[self.filename] = ''
    
    def read(self, size=-1):
        if self.closed:
            raise ValueError("I/O operation on closed file")
        if 'r' not in self.mode and 'a' not in self.mode:
            raise IOError("File not open for reading")
        if size == -1:
            result = self.content[self.position:]
            self.position = len(self.content)
        else:
            result = self.content[self.position:self.position + size]
            self.position += size
        return result
    
    def readline(self):
        if self.closed:
            raise ValueError("I/O operation on closed file")
        if 'r' not in self.mode and 'a' not in self.mode:
            raise IOError("File not open for reading")
        newline_pos = self.content.find('\\n', self.position)
        if newline_pos == -1:
            result = self.content[self.position:]
            self.position = len(self.content)
        else:
            result = self.content[self.position:newline_pos + 1]
            self.position = newline_pos + 1
        return result
    
    def readlines(self):
        if self.closed:
            raise ValueError("I/O operation on closed file")
        lines = []
        while True:
            line = self.readline()
            if not line:
                break
            lines.append(line)
        return lines
    
    def write(self, content):
        if self.closed:
            raise ValueError("I/O operation on closed file")
        if 'w' not in self.mode and 'a' not in self.mode:
            raise IOError("File not open for writing")
        if 'a' in self.mode:
            self.content += content
        else:
            self.content = self.content[:self.position] + content + self.content[self.position + len(content):]
            self.position += len(content)
        _virtual_files[self.filename] = self.content
    
    def writelines(self, lines):
        for line in lines:
            self.write(line)
    
    def seek(self, offset, whence=0):
        if self.closed:
            raise ValueError("I/O operation on closed file")
        if whence == 0:
            self.position = offset
        elif whence == 1:
            self.position += offset
        elif whence == 2:
            self.position = len(self.content) + offset
    
    def tell(self):
        return self.position
    
    def close(self):
        if not self.closed:
            _virtual_files[self.filename] = self.content
            self.closed = True
    
    def __enter__(self):
        return self
    
    def __exit__(self, exc_type, exc_val, exc_tb):
        self.close()
        return False
    
    def __iter__(self):
        return self
    
    def __next__(self):
        line = self.readline()
        if not line:
            raise StopIteration
        return line

def open(filename, mode='r', encoding=None):
    return VirtualFile(filename, mode)

def listdir(path='.'):
    path = _normalize_path(path)
    result = set()
    for filepath in _virtual_files.keys():
        if filepath.startswith(path + '/'):
            remaining = filepath[len(path) + 1:]
            if '/' in remaining:
                result.add(remaining.split('/')[0])
            else:
                result.add(remaining)
    return list(result)

def path_exists(path):
    path = _normalize_path(path)
    return path in _virtual_files or any(f.startswith(path + '/') for f in _virtual_files.keys())

def path_isfile(path):
    path = _normalize_path(path)
    return path in _virtual_files

def path_isdir(path):
    path = _normalize_path(path)
    if path in _virtual_files:
        return False
    return any(f.startswith(path + '/') for f in _virtual_files.keys())

def remove(path):
    path = _normalize_path(path)
    if path in _virtual_files:
        del _virtual_files[path]
    else:
        raise FileNotFoundError(f"No such file: {path}")

def mkdir(path):
    pass

def makedirs(path):
    pass

def getcwd():
    return _virtual_cwd

def chdir(path):
    global _virtual_cwd
    _virtual_cwd = _normalize_path(path)

class _VirtualPath:
    exists = staticmethod(path_exists)
    isfile = staticmethod(path_isfile)
    isdir = staticmethod(path_isdir)
    join = staticmethod(lambda *args: '/'.join(str(a).rstrip('/') for a in args if a))
    dirname = staticmethod(lambda p: '/'.join(_normalize_path(p).split('/')[:-1]) or '/')
    basename = staticmethod(lambda p: _normalize_path(p).split('/')[-1])
    split = staticmethod(lambda p: (_VirtualPath.dirname(p), _VirtualPath.basename(p)))
    splitext = staticmethod(lambda p: (p.rsplit('.', 1)[0] if '.' in p else p, '.' + p.rsplit('.', 1)[1] if '.' in p else ''))
    abspath = staticmethod(_normalize_path)

class _VirtualOs:
    listdir = staticmethod(listdir)
    remove = staticmethod(remove)
    mkdir = staticmethod(mkdir)
    makedirs = staticmethod(makedirs)
    getcwd = staticmethod(getcwd)
    chdir = staticmethod(chdir)
    path = _VirtualPath
    curdir = '.'
    pardir = '..'
    sep = '/'
    linesep = '\\n'

_sys_module.modules['os'] = _VirtualOs
`;

export function getVirtualFileSystemCode(): string {
  return VIRTUAL_FILE_SYSTEM_CODE;
}